import React, { useState, useEffect } from 'react';
import {
	useHawksearch,
	ToolRow,
	ResultListing,
	AutoCorrectSuggestion,
	SearchResultsLabel,
	Selections,
} from 'react-hawksearch';
import ExtendedResultItem from 'components/hawk-sdk-overrides/ExtendedResultItem';
import Tabs from 'components/results/Tabs';
function PreviewResults() {
	const {
		store: { isLoading, searchResults },
	} = useHawksearch();
	// end of overrides
	const matchImageHeight = () => {
		const nodeList = document.getElementsByClassName('match-image-height');
		const elems = [].slice.call(nodeList);
		const tallest = Math.max.apply(
			Math,
			elems.map((elem, index) => {
				elem.style.height = ''; // clean first
				return elem.offsetHeight;
			})
		);
		elems.forEach((elem, index, arr) => {
			elem.style.height = tallest + 'px';
		});
	};

	const matchPriceHeight = () => {
		const nodeList = document.getElementsByClassName('match-price-height');
		const elems = [].slice.call(nodeList);
		const tallest = Math.max.apply(
			Math,
			elems.map((elem, index) => {
				elem.style.height = ''; // clean first
				return elem.offsetHeight;
			})
		);
		elems.forEach((elem, index, arr) => {
			elem.style.height = tallest + 'px';
		});
	};

	window.addEventListener('resize', matchImageHeight);
	window.addEventListener('resize', matchPriceHeight);
	useEffect(() => {
		matchImageHeight();
		matchPriceHeight();
	});

	if ((!searchResults || searchResults.Results.length === 0) && !isLoading) {
		return (
			<div className="hawk-results">
				<div className="product-grid">
					<AutoCorrectSuggestion />
					<h2>No Results Available</h2>
				</div>
			</div>
		);
	}

	return (
		<div className="hawk-results">
			<Tabs />
			<SearchResultsLabel />
			<Selections />
			<div className="hawk-results__top-tool-row">
				<ToolRow />
			</div>
			<ResultListing ResultItem={ExtendedResultItem} />
			<div className="hawk-results__bottom-tool-row">
				<ToolRow />
			</div>
		</div>
	);
}

export default PreviewResults;
